import { Role } from '@caresend/types';
import { computed } from 'vue';
import { getStore } from '../store/helpers/initStore.js';

const useUserRole = () => {
    const store = getStore();
    const role = computed(() => store.getters['auth/getUserRole']);
    const isAssistant = computed(() => role.value === Role.ASSISTANT);
    const isNurse = computed(() => role.value === Role.NURSE);
    const isPacker = computed(() => role.value === Role.PACKER);
    const isPatient = computed(() => role.value === Role.PATIENT);
    const isPrescriber = computed(() => role.value === Role.PRESCRIBER);
    const isRecruiter = computed(() => role.value === Role.RECRUITER);
    const isSuperAdmin = computed(() => role.value === Role.SUPERADMIN);
    const isUnauthed = computed(() => !role.value);
    const isDashboardUser = computed(() => isRecruiter.value || isSuperAdmin.value);
    const isProUser = computed(() => isAssistant.value || isNurse.value || isPacker.value || isPrescriber.value);
    const isOfficeStaff = computed(() => isAssistant.value || isPrescriber.value);
    return {
        isAssistant,
        isDashboardUser,
        isNurse,
        isPacker,
        isPatient,
        isPrescriber,
        isProUser,
        isOfficeStaff,
        isRecruiter,
        isSuperAdmin,
        isUnauthed,
        role,
    };
};

export { useUserRole };
